export default {
  // 页面标题
  title: "调证建议",

  // 统计信息
  statistics: {
    totalPrefix: "共计",
    totalSuffix: "条数据",
  },

  // 复选框
  hideNonKeyPoint: "隐藏非重点调证",

  // 按钮
  downloadChecklist: "下载调证清单",

  // 加载和空状态
  loading: "拼命加载中",
  empty: "暂无数据",
  emptyTip: "请在画布中选择节点后右键或者点击右侧的加入调证按钮",

  // 调证优先级
  priority: {
    normal: "普通调证",
    high: "重点调证",
  },

  // 调证状态
  status: {
    pending: "待调证",
    success: "调证成功",
    failed: "调证失败",
    waiting: "待调证返回",
  },
};
